module.exports = __webpack_public_path__ + "static/img/european_commission.009a3cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/european_commission.png
// module id = 131
// module chunks = 0